import assign from 'lodash/assign'; 

import './TaxonomyFilters.scss';
import template from './TaxonomyFilters.vhtml';

export default {
	name: 'TaxonomyFilters',
	template: template,
	props: {
		'taxonomies': {
			'type': Array,
			'default': () => [],
		},
		'chosen': {
			'type': Object,
			'default': () => { },
		},
	},
	data: () => ({
		chosenInternal: {},
	}),
	watch: {
		chosenInternal() {
			this.$emit('change', this.chosenInternal);
		},
		chosen(value) {
			this.chosenInternal = value;
		},
	},
	methods: {
		handleChange(results) {
			this.chosenInternal = assign({}, this.chosenInternal, results);
		},
	},
	created() {
		this.chosenInternal = this.chosen;
	}
};
